export default function (localizer, items, prop = 'label', localMap = 'localeMap') {
  return items.map(item => {
    return {
      ...item,
      [prop]: item[localMap] ? localizer(item[localMap]) : item[prop]
    };
  })
}
